// WhatsApp message templates for AS TRAINING coach
export const WHATSAPP_TEMPLATES = [
  {
    id: "welcome",
    category: "Bienvenida",
    title: "Mensaje de bienvenida general",
    body: `¡Hola! 👋 Bienvenido(a) a *AS TRAINING* 💚

Soy tu coach y estoy aquí para acompañarte en tu transformación.

📌 Nuestro lema: *TRANSFORMANDO CUERPOS, CAMBIANDO VIDAS.*

¿Estás listo(a) para comenzar tu cambio? Cuéntame un poco sobre tus objetivos y diseñaremos juntos el mejor plan para ti. 💪`,
  },
  {
    id: "new-client",
    category: "Nuevos clientes",
    title: "Mensaje para nuevos clientes",
    body: `¡Excelente decisión! 🎯

Te doy la más cordial bienvenida a la familia *AS TRAINING*. 

Para iniciar con tu plan personalizado, necesito que completes el *Formulario de Evaluación Profesional* aquí:
👉 [ENLACE_FORMULARIO]

Una vez recibido, en menos de 48 horas tendrás tu plan a la medida:
✅ Plan nutricional
✅ Rutina de entrenamiento
✅ Hojas de seguimiento

¡Vamos por esa mejor versión de ti! 💚`,
  },
  {
    id: "payment-received",
    category: "Pagos",
    title: "Pago recibido",
    body: `¡Pago confirmado! ✅

Hola [NOMBRE], hemos recibido tu pago correctamente para el plan *[PLAN]*. 

🧾 Monto: $[MONTO]
📅 Fecha: [FECHA]
🆔 Referencia: [REFERENCIA]

En las próximas 24-48 horas recibirás tu programa completo. ¡Bienvenido(a) oficialmente al equipo *AS TRAINING*! 💚💪`,
  },
  {
    id: "program-delivery",
    category: "Entrega",
    title: "Entrega del programa",
    body: `¡Hola [NOMBRE]! 📋

Tu programa personalizado está listo:

📎 *Plan Nutricional* (PDF)
📎 *Rutina de Entrenamiento* (PDF)
📎 *Hoja de Seguimiento*

📌 *Indicaciones importantes:*
• Sigue el plan al pie de la letra durante las primeras 2 semanas
• Toma fotos de progreso cada 15 días
• Pésate 1 vez por semana, mismo día y misma hora
• Cualquier duda, escríbeme

¡Empezamos! 🚀💚`,
  },
  {
    id: "followup-week",
    category: "Seguimiento",
    title: "Seguimiento semanal",
    body: `¡Hola [NOMBRE]! 📊

¿Cómo va tu semana? Es momento de tu check-in:

1️⃣ ¿Cuál es tu peso actual?
2️⃣ ¿Cómo te has sentido con la rutina?
3️⃣ ¿Has tenido alguna dificultad con la alimentación?
4️⃣ ¿Energía en los entrenamientos?

Envíame también tu foto de progreso si toca esta semana. 📸

¡Sigamos avanzando! 💪💚`,
  },
  {
    id: "motivation-1",
    category: "Motivación",
    title: "Motivación lunes",
    body: `💚 *LUNES DE PODER* 💚

"La disciplina es elegir entre lo que quieres ahora y lo que quieres más."

Hoy puede ser el día que cambies tu historia. ¿Estás dentro? 💪

#ASTraining #TransformandoCuerpos`,
  },
  {
    id: "motivation-2",
    category: "Motivación",
    title: "Motivación entrenamiento",
    body: `🔥 No es magia. Es DISCIPLINA, CONSTANCIA y RESULTADOS.

Cada repetición cuenta. Cada comida cuenta. Cada día cuenta.

Tú decides hasta dónde quieres llegar. 💚

*AS TRAINING – Transformando cuerpos, cambiando vidas.*`,
  },
  {
    id: "reactivation",
    category: "Seguimiento",
    title: "Reactivación",
    body: `Hola [NOMBRE] 👋

Hace unos días que no recibo noticias tuyas. ¿Todo bien?

Recuerda que la consistencia es la clave de los resultados. Si necesitas ajustar algo del plan o tienes alguna duda, estoy aquí para ayudarte.

¡No abandones tu meta! 💪💚`,
  },
];
